import essApi from "../axios/essApi";

class RoleService {
  async getRoles() {
    return Promise.resolve(essApi.get("roles"));
  }
  async createRoles(reqBody) {
    return Promise.resolve(essApi.post("role", reqBody));
  }
  async deleteRole(id) {
    return Promise.resolve(essApi.delete(`deleteRoleById/${id}`));
  }
}

export default RoleService;
